// extracted by mini-css-extract-plugin
export var card = "_8o-1";
export var container = "_8o-0";